import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#6CAF35',
        secondary: '#4B5320',
        accent: '#FFB703',
        error: '#D7263D',
        info: '#219EBC',
        success: '#1E7D22',
        warning: '#F4A261',
      },
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
})
